import { useEffect, useState } from "react"
import TableWidget from "../../../../widgets/table/tableWidget/TableWidget"
import LoaderWrapper from "../../../../widgets/loaderWrapper/LoaderWrapper"
import { useDispatch } from "react-redux"
import { useGetTablesStructureQuery, useLazyGetTableValueQuery } from "../../../../api/rtk/base/slices/tablesApiSlice"
import { getBasicTablePaginator } from "../../../../widgets/table/tableFeatures/tableTemplates/tablePaginatorTemplates"
import { configureTableLazyState, defineTableColumnsFromColumnsStructureObject, mergeColumns, tableColumnExtensions, TableEvents, tableStateModifyHandle } from "../../../../widgets/table/tableFeatures/tableFunctions"
import { prepareQueryArgsForTableFetch } from "../../../../widgets/table/tableFeatures/tableFetchFunctions"
import { getValueWithMapLinks, prepareTableData } from "../../../../features/dataFormatFunctions/dataFormatter"
import { showToastMessage } from "../../../../stateManagement/reducers"
import ObjectTypesList from "./ObjectTypesList"
import { getItemWebStorage } from "src/features/webStorageSaver"

type TableUnderMapGroupProps = {
    mapName?: string,
    objectTypes: string[],
    canBeFiltered: boolean,
    filters: any
}

export default function TableUnderMapMultiType({ mapName, objectTypes, canBeFiltered, filters }: TableUnderMapGroupProps) {
    const dispatch = useDispatch()
    const [currentObjectType, setCurrentObjectType] = useState<string>(objectTypes[0])
    const [columns, setColumns] = useState<any>([])
    const [tableState, setTableState] = useState<any>(null)
    const [tableValueUrl, setTableValueUrl] = useState<string>('')
    const [paginator, setPaginator] = useState<any>({})
    const [paginatorPageInputTooltip, setPaginatorPageInputTooltip] = useState<any>('Введите номер страницы.')
    const [tableValue, setTableValue] = useState<any>([])
    const [tableLoading, setTableLoading] = useState<boolean>(true)
    const [dataCount, setDataCount] = useState<number | undefined>()
    const currentConfig = getItemWebStorage("currentConfig");
    const structureSuffix = currentConfig?.structureSuffix

    const {
        data: tablesStructure,
        isError: isErrorTableStructure,
    } = useGetTablesStructureQuery({ structureSuffix })

    const [fetchTableValue, { isError: isErrorTableValue }] = useLazyGetTableValueQuery()

    useEffect(() => {
        const paginatorTemplate = getBasicTablePaginator(paginatorPageInputTooltip, setPaginatorPageInputTooltip, tableState, setTableState, dataCount, currentObjectType)
        setPaginator(paginatorTemplate)
    }, [dataCount, tableState, paginatorPageInputTooltip])

    useEffect(() => {
        if (tablesStructure && currentObjectType) {
            let columnsStructure: any = tablesStructure[currentObjectType]
            const tableValueUrl = (columnsStructure?.url)
            let columns = defineTableColumnsFromColumnsStructureObject(columnsStructure, canBeFiltered, 'highlight', true, tableValueUrl)
            if (mapName) {
                const exts = tableColumnExtensions[mapName] ?? [];
                columns = mergeColumns(columns, exts);
            }
            setTableState(configureTableLazyState({}))
            setColumns(columns)
            setTableValueUrl(tableValueUrl)
        }
    }, [tablesStructure, currentObjectType])

    async function getTableValue(tableState: any) {
        setTableLoading(true)
        const { sortString, filterStringArray, page }: any = prepareQueryArgsForTableFetch(tableState, columns)
        const { data: tableValueResponse } = await fetchTableValue({
            tableValueUrl,
            pages: true,
            top: 100,
            order: sortString,
            filterString: filters[currentObjectType],
            filterStringArray,
            skip: page * 100
        })
        let value = tableValueResponse?.value
        value = getValueWithMapLinks(value, currentObjectType)
        value = prepareTableData(value, columns)
        setTableValue(value)
        let dataCount = tableValueResponse?.['@xdata.count']
        setDataCount(dataCount)
        setTableLoading(false)
    }

    useEffect(() => {
        if (tableValueUrl && columns) {
            getTableValue(tableState)
        }
    }, [tableValueUrl, tableState, columns, filters])

    const onSort = (state: any) => tableStateModifyHandle(state, TableEvents.sort, setTableState, null, false)
    const onPage = (state: any) => tableStateModifyHandle(state, TableEvents.page, setTableState, null, false)
    const onFilter = (state: any) => tableStateModifyHandle(state, TableEvents.filter, setTableState, null, false)

    useEffect(() => {
        if (isErrorTableStructure || isErrorTableValue) {
            setTableLoading(false)
        }
    }, [isErrorTableStructure, isErrorTableValue])


    useEffect(() => {
        if (isErrorTableValue || isErrorTableStructure) {
            dispatch(showToastMessage({ messageText: "Ошибка загрузки таблицы", messageType: "error" }))
        }
    }, [isErrorTableValue, isErrorTableStructure])

    return (
        <div className="table-under-map-group-div">
            <ObjectTypesList
                objectTypes={objectTypes}
                currentObjectType={currentObjectType}
                setCurrentObjectType={setCurrentObjectType}
            />
            <div className="table-widget-with-toast with-object-types-list">
                <LoaderWrapper isLoading={tableLoading} >
                    <TableWidget
                        tableValue={tableValue}
                        tableState={tableState}
                        columns={columns}
                        dataCount={dataCount}
                        paginatorTemplate={paginator}
                        pageSize={100}
                        onPage={onPage}
                        onSort={onSort}
                        onFilter={onFilter}
                        canBeFiltered={canBeFiltered}
                        isLazy={true}
                    />
                </LoaderWrapper>
            </div>
        </div>
    )
}
